// @flow
import * as React from "react"
import { breakpoints } from "common/mediaQuery"
import MediaQuery from "components/MediaQuery"

type Props = {|
  children: React.Node,
  breakpoint?: number,
|}

const Desktop = ({ children, breakpoint = breakpoints.tabletWide }: Props) => (
  <MediaQuery breakpoint={breakpoint}>
    {matches => !matches && children}
  </MediaQuery>
)

export default Desktop



// WEBPACK FOOTER //
// ./src/components/Media/Desktop.js